import styled from 'styled-components';

export const Box = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #f2f2f2;
  border-radius: 4px;
`;

const BaseInfo = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Name = styled(BaseInfo)`
  font-weight: 700;
`;
export const Email = styled(BaseInfo)``;
export const Phone = styled(BaseInfo)``;
export const Identity = styled(BaseInfo)``;

export const Icon = styled.div`
  display: flex;
  width: 16px;
`;
export const Value = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
